module.exports = __webpack_public_path__ + "img/erp04.60ab836b.jpg";